<template>
  <div class="ab-quality">
    <AbBlock title="发现更多优质客户" subTitle="随时随地获取新商机">
      <div class="q-list">
        <a-row :gutter="24">
          <a-col :span="6" class="q-item">
            <div class="item-default flex-col justify-between">
              <div class="def-img">
                <img src="~@/assets/product/插图_全品类细分触达.png" />
              </div>
              <div class="def-text fontsize26">
                海量优质线索
              </div>
            </div>
            <div class="hover-item">
              <div class="title fontsize26">
                海量优质线索
              </div>
              <div class="desc fontsize16">
                询盘市场都为人工审核过滤的优质线索，满足不同行业客户采购需求，无需繁杂的搜客流程，多种筛选条件快速检索潜在客户，有效节约销售人员大量寻找客户的时间成本。
              </div>
              <a-button size="large" type="primary"
                ><a
                   @click="showModal"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register" 
                  target="_blank"
                  >立即体验</a
                ></a-button
              >
            </div>
          </a-col>
          <a-col :span="6" class="q-item">
            <div class="item-default flex-col justify-between">
              <div class="def-img">
                <img src="~@/assets/product/插图_全域触点联动.png" />
              </div>
              <div class="def-text fontsize26">
                全域触点联动
              </div>
            </div>
            <div class="hover-item">
              <div class="title fontsize26">
                全域触点联动
              </div>
              <div class="desc fontsize16">
                基于完善的产品矩阵体系，打通各渠道营销数据，构建统一的客户视图，有效盘活客户资源，快速完成跨平台进行营销触达，激活潜在线索价值，加速业务营销增长。
              </div>
              <a-button size="large" type="primary"
                ><a
                   @click="showModal"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register" 
                  target="_blank"
                  >立即体验</a
                ></a-button
              >
            </div>
          </a-col>
          <a-col :span="6" class="q-item">
            <div class="item-default  flex-col justify-between">
              <div class="def-img">
                <img src="~@/assets/product/插图_智能防撞单机制.png" />
              </div>
              <div class="def-text fontsize26">
                智能防撞单机制
              </div>
            </div>
            <div class="hover-item">
              <div class="title fontsize26">
                智能防撞单机制
              </div>
              <div class="desc fontsize16">
                智能防撞单机制，自研算法智能分层、分类、合并、归档，动态调度监控分析，行业数据安全加密备份与隔离，降低询盘线索外溢风险，杜绝跨境交易存在的其他隐患。
              </div>
              <a-button size="large" type="primary"
                ><a
                   @click="showModal"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register" 
                  target="_blank"
                  >立即体验</a
                ></a-button
              >
            </div>
          </a-col>
          <a-col :span="6" class="q-item">
            <div class="item-default flex-col justify-between">
              <div class="def-img">
                <img src="~@/assets/product/插图_管理拓展灵活.png" />
              </div>
              <div class="def-text fontsize26">
                管理拓展灵活
              </div>
            </div>
            <div class="hover-item">
              <div class="title fontsize26">
                管理拓展灵活
              </div>
              <div class="desc fontsize16">
                智能化的客户分配与回收，高度贴合企业用户需求，聚焦可视化客户旅程设计，在客户旅程各阶段自动触发营销动作，实现智能化营销培育，提升线索转化效率。
              </div>
              <a-button size="large" type="primary"
                ><a
                   @click="showModal"  data-source="p"  onmouseover="linkDataSource(this)"    a-type="register" 
                  target="_blank"
                  >立即体验</a
                ></a-button
              >
            </div>
          </a-col>
        </a-row>
      </div>
    </AbBlock>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import AbBlock from '@/components/AbBlock.vue';
import inquiryModalVue from "@/components/InquiryModal2.vue";
export default {
  components: {
    AbBlock,
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },}
};
</script>

<style lang="sass" scoped>
.ab-quality{
  width: 100%;
  height: 100%;
  padding: 60px 0px;
  padding-bottom:100px;

  .q-list{
    padding-top: 97px;
    .ant-row{
      background:#fff;
    }
    .q-item:last-child{
      border:none
    }
    .q-item{
      border-right:2px solid #D6EAFF;
      position: relative;
      padding: 39px 72px 23px 73px;

      .item-default{
        text-align: center;
        .def-text{
          font-family: AlibabaPuHuiTiM, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #333646;
          line-height: 35px;
          padding-top:60px;
          padding-bottom:20px;
        }
      }
      &:hover .hover-item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
         transition: all .3s;
         top:-50px;
         left:0px;

      }
      .hover-item {
        position: absolute;
        top: 0;
        width: 100%;
        height: 470px;
         display: none;
        align-items: center;
        justify-content: center;
        background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
        box-shadow: 0px 10px 20px 10px rgba(43,104,255,0.3000);
        border-radius: 8px;
        padding: 59px 57px 40px 58px;
        text-align: center;
        transform: translateZ(0);
    transition: all .3s;

        .title{

          font-family: 'Alibaba-PuHuiTi-R';
            font-weight: normal;
            color: #FFFFFF;
            line-height: 35px;
        }
         .ant-btn-primary:hover{
          background:#fff;
          color:#198BFF
         }
        .ant-btn-primary{
          width: 200px;
height: 64px;  font-family: 'Alibaba-PuHuiTi-R';
border-radius: 6px;
border: 1px solid #FFFFFF;
font-size: 20px;
background:transparent
        }
        .desc{
         height:230px;
         margin-top:30px;
          font-family: 'Alibaba-PuHuiTi-R';
          font-weight: normal;
          color: #FFFFFF;
          line-height: 30px;
          text-align: left;
        }
      }
    }
  }
}
</style>
